import { render, staticRenderFns } from "./totalDiscount.vue?vue&type=template&id=c835053a&scoped=true&"
import script from "./totalDiscount.vue?vue&type=script&lang=js&"
export * from "./totalDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c835053a",
  null
  
)

export default component.exports